import React, { Suspense } from "react";
import { Provider } from "react-redux";
import store from "./store/store";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Loader from "./utils/Loader";
import ErrorBoundary from "./components/common/ErrorBoundary";

function App() {
  const router = createBrowserRouter(createRoutesFromElements(PrivateRoute()));
  return (
    <>
      <ErrorBoundary>
        <Provider store={store}>
          <div className="App">
            <Suspense fallback={<Loader loader />}>
              <RouterProvider router={router} />
            </Suspense>
          </div>
        </Provider>
      </ErrorBoundary>
    </>
  );
}

export default App;
